// 토스 클라이언트 키는 브라우저에 노출되는 공개 키다.
// 시크릿은 Pages Function 환경변수에만 둔다.

/** 일반결제(위젯) — mk85 상점. 지금 c2 바로결제에 사용. */
export const TOSS_WIDGET_CLIENT_KEY = 'live_gck_mBZ1gQ4YVXBy7mJEzdYx8l2KPoqN';

/** 자동결제(빌링) 테스트 클라이언트 키. 포토북 테스트 결제에만 사용. */
export const TOSS_BILLING_CLIENT_KEY = 'test_ck_ODnyRpQWGrNm4na1YLBVKwv1M9EN';
